import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { PageWrapper } from 'libs.react';
import { Chat } from './chat.component';
import { ChatContext } from '../contexts/chat.context';
export const ChatContainer = ({ children, chatProps }) => {
    const { isEnabled } = useContext(ChatContext);
    return (_jsxs("div", { className: 'flex h-full', children: [_jsx(PageWrapper, { children: children }), isEnabled && _jsx(Chat, { conversationKey: chatProps.conversationKey, systemPrompt: chatProps.systemPrompt })] }));
};
